import React, { useState } from 'react';
import { Button } from 'antd';
import ServerInstallProgress from '../components/ServerInstallProgress';

const TestProgressPage: React.FC = () => {
  const [showProgress, setShowProgress] = useState(false);
  const [serverId, setServerId] = useState<number | null>(null);

  const handleTestProgress = () => {
    setServerId(999);
    setShowProgress(true);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>测试进度条</h1>
      <Button type="primary" onClick={handleTestProgress}>
        显示进度条
      </Button>
      
      <ServerInstallProgress
        visible={showProgress}
        onClose={() => setShowProgress(false)}
        serverId={serverId}
        serverName="测试服务器"
        socket={null}
      />
    </div>
  );
};

export default TestProgressPage;

















